<template functional>
  <v-flex class="nx-bag-block-button">
    <v-btn
      color="secondary"
      class="ma-0"
      block
      :loading="props.loading"
      v-on="listeners"
    >
      {{ props.title }}
    </v-btn>
  </v-flex>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
    },
  },
};
</script>

<style lang="stylus">
.nx-bag-block-button {
  padding: 15px 20px;
}
</style>
